import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { C as Card } from '../Card/Card-B4HxDDFs.js';
import { f as focusOutline } from '../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { C as Content } from './Content/Content-D32f6TK9.js';
import { a as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { D as DefaultTitle } from './DefaultTitle/DefaultTitle-BeybgKQL.js';
import { D as DefaultFooter } from './DefaultFooter/DefaultFooter-BvoHUEFA.js';
import { D as DefaultBody } from './DefaultBody/DefaultBody-BqZKgWS5.js';
import { D as DefaultImage } from './DefaultImage/DefaultImage-CR6FleVs.js';

const StyledTitle = /*#__PURE__*/styled('span').withConfig({
  componentId: "sc-storm-ui-40025937__sc-p8lviz-0"
})(["word-break:break-word;"]);
const StyledCard = /*#__PURE__*/styled(Card).withConfig({
  componentId: "sc-storm-ui-40025937__sc-p8lviz-1"
})(["box-sizing:border-box;", ""], ({
  $isSelected,
  theme
}) => $isSelected && css(["background-color:", ";border:", ";"], theme.selectableContainer.backgroundColor.selected, theme.selectableContainer.border.selected));
const FooterButton = /*#__PURE__*/styled.button.withConfig({
  componentId: "sc-storm-ui-40025937__sc-p8lviz-2"
})(["display:flex;align-items:center;font:", ";color:", ";background-color:unset;border:unset;width:100%;text-align:start;padding-block:", ";padding-inline:", ";", " cursor:pointer;border-radius:", ";:focus-visible{", "}:active{color:unset;}"], ({
  theme
}) => theme.font.text.base.default, ({
  theme
}) => theme.text.color.default, ({
  theme
}) => theme.spacing.xxsmall.default, ({
  theme
}) => theme.spacing.xxsmall.default, isMobile(css(["padding-block:", ";padding-inline:", ";"], ({
  theme
}) => theme.spacing.xxsmall.mobile, ({
  theme
}) => theme.spacing.xxsmall.mobile)), ({
  theme
}) => `0 0 ${theme.border.radius.large} ${theme.border.radius.large}`, focusOutline);
FooterButton.displayName = 'FooterButton';
const CardListItem = ({
  id,
  className = '',
  isSelected = false,
  onSelect,
  onClick,
  title,
  footer,
  onFooterClick,
  ariaLabel,
  children,
  taktId,
  taktValue,
  ...restProps
}) => /*#__PURE__*/React__default.createElement(StyledCard, {
  className: className,
  id: id,
  padding: "none",
  $isSelected: isSelected,
  taktId: taktId
}, /*#__PURE__*/React__default.createElement(Content, _extends({}, restProps, {
  id: id,
  isSelected: isSelected,
  onSelect: onSelect,
  onClick: onClick,
  ariaLabel: ariaLabel
}), /*#__PURE__*/React__default.createElement(StyledTitle, null, title), children), footer && /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('card-footer')
}, ({
  getDataTaktAttributes
}) => /*#__PURE__*/React__default.createElement(FooterButton, _extends({}, getDataTaktAttributes(), {
  onClick: event => onFooterClick && onFooterClick(event),
  type: "button"
}), footer)));
CardListItem.DefaultTitle = DefaultTitle;
CardListItem.DefaultFooter = DefaultFooter;
CardListItem.DefaultBody = DefaultBody;
CardListItem.DefaultImage = DefaultImage;

export { CardListItem as C };
//# sourceMappingURL=CardListItem-uZYVwOHL.js.map
